import React, { Component } from 'react';
import $ from 'jquery';

const viewsToLimitAction = []// ["orderSales", "invoice", "deliveries"];

class CreditLimitModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeConfirm = async () => {
        const { clearSocio } = this.props;
        clearSocio();
        $('#creditLimitModal').modal('hide');
    }

    closeAction = () => {
        $('#creditLimitModal').on('hidden.bs.modal', function () {
        });
    };
    Continue = () => {
        // const {newOrderModel,createDocument} =this.props;
        // createDocument(newOrderModel);
        $('#creditLimitModal').modal('hide');
    }

    handleContent = () => {
        const { view } = this.props;

        if (viewsToLimitAction.includes(view)) {
            return {
                message: "No podrá transaccionar con este socio",
                confirmLbl: "Aceptar",
                exception: true
            };
        }

        return {
            message: "¿Deseas continuar?",
            confirmLbl: "No",
            exception: false
        };
    }

    render() {
        const { Balance, Codigo, CardName } = this.props;
        const { message, confirmLbl, exception } = this.handleContent();

        return (
            <div className="modal" tabIndex="-1" role="dialog" id="creditLimitModal" data-backdrop="static" data-keyboard="false" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <p>"{Codigo}-{CardName}" Límite de crédito excedido en {Balance}</p>
                            <p>{message}</p>
                        </div>
                        <div className="modal-footer">
                            {!exception && (
                                <button type="button" className="btn botonCerrar text-white" onClick={this.Continue}> Si </button>
                            )}
                            <button type="button" className="btn botonCorrect text-black" onClick={this.closeConfirm}>{confirmLbl}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default CreditLimitModal;